export const getRequestFilter = (request = {}) => {
  const result = {};

  for (const key in request) {
    const item = request[key];
    const isItem = Boolean(item);

    if (Array.isArray(item)) {
      if (item.length > 0) {
        result[key] = item;
      }
    } else if (typeof item === 'boolean') {
      result[key] = item;
    } else if (typeof item === 'number') {
      result[key] = item;
    } else if (isItem) {
      result[key] = item;
    }
  }

  return result;
};
